import './common.scss'
import { useContext, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import utility from 'src/utils/utility'
import { Header } from 'src/component'

export const CommonRoutes = () => {
    const {recoverStatesData} = useContext(AppInfoContext)

    useEffect(() => {
        recoverStatesData()
    }, [])
    
    return (
        <div className="common-container">
            <Header />
            <div className="common-modules">
                <Outlet/>
            </div>
        </div>
    )
}

export default utility.routeData('general', 'Common', <CommonRoutes/>)
